import { useMasterDocumentTranslation } from './i18n';
import { CanonTabsBar } from './CanonTabsBar';
import type { LineTabsBarProps } from './MasterDocument.types';

/**
 * Barra de pestañas del área de detalle.
 *
 * Delega TODO el aspecto y el teclado en {@link CanonTabsBar}, que es el único dueño del
 * estilo de pestañas de `MasterDocument`.
 *
 * **Cambio de aspecto deliberado (2026-09-04).** Hasta aquí esta barra pintaba chips
 * `rounded-md` con `bg-primary-custom-100`, heredados de la tira de dos botones que
 * `MasterDocument` traía quemada para el cruce, y `HeaderRenderer` pintaba un tercer diseño
 * con subrayado. Ninguno de los dos era el canon de MasterCrud (ADR-027 §C.2), así que un
 * usuario que pasaba de un maestro a un documento veía tres barras de pestañas distintas.
 * Ahora las dos salen del mismo componente.
 *
 * Lo que NO cambia: el contrato de `id`s de ARIA (`line-tab-{key}` para la pestaña y
 * `line-tabpanel-{key}` para el panel, que `LineTabsRegion` referencia con
 * `aria-labelledby`), la navegación por flechas ←/→ e Inicio/Fin, el `tabIndex` rotatorio y
 * el scroll horizontal. Esta barra sigue sin decidir nada: recibe las pestañas resueltas y
 * la activa, y avisa del cambio.
 *
 * @see CanonTabsBar — el canon §C.2, con el indicador deslizante
 * @see LineTabsRegion — monta el contenido de la pestaña activa
 */
export function LineTabsBar({ tabs, activeKey, onChange, className }: LineTabsBarProps) {
  const { t } = useMasterDocumentTranslation();

  return (
    <CanonTabsBar
      tabs={tabs.map((tab) => ({ key: tab.key, label: tab.label, icon: tab.icon }))}
      activeKey={activeKey}
      onChange={onChange}
      ariaLabel={t('master_document.lines.tabsLabel')}
      idPrefix="line-tab"
      testId="line-tabs"
      className={className}
    />
  );
}
